import { useEffect } from "react";
import {
  Stack,
  Typography,
  IconButton,
  Chip,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DoneAll from "@mui/icons-material/DoneAll";
import { useGuardiasIncidencias } from "../../hooks/useGuardias";

type Props = { turnoId?: number };

export default function IncidenciasList({ turnoId }: Props) {
  const { rows, loading, refresh, resolver } = useGuardiasIncidencias({
    turnoId,
    estado: undefined,
  });

  useEffect(() => {
    refresh(); /* eslint-disable-next-line */
  }, [turnoId]);

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1">Incidencias</Typography>
        <IconButton size="small" onClick={refresh} disabled={loading}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>
      <List dense>
        {rows.map((i) => (
          <ListItem key={i.id} divider>
            <ListItemText
              primary={`${i.tipo.replace(/_/g, " ")} – usuario ${i.usuarioId}`}
              secondary={i.mensaje ?? ""}
            />
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                size="small"
                label={i.estado}
                color={i.estado === "abierta" ? "warning" : "success"}
              />
              {i.estado === "abierta" && (
                <Tooltip title="Marcar resuelta">
                  <IconButton onClick={() => resolver(i.id)}>
                    <DoneAll />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          </ListItem>
        ))}
        {rows.length === 0 && (
          <ListItem>
            <ListItemText primary="Sin incidencias" />
          </ListItem>
        )}
      </List>
    </Stack>
  );
}
